import { trackingGaEventNew } from './gtm'

const getCurrentPosition = (path: string) => {
  if (path === '/') {
    return 'homepage'
  }

  return path
}

export const handleClickCategoryTracking = (label: string, path: string) => {
  trackingGaEventNew('click_category', {
    searchTerm: '',
    position: getCurrentPosition(path),
    label: label && typeof label === 'string' ? label.toLowerCase().replaceAll(' ', '_') : '',
    type: '',
    step: '',
    category: '',
    action: '',
  })
}

export const handleDownloadTracking = (label: string, type: string, path: string) => {
  trackingGaEventNew('download', {
    searchTerm: '',
    position: getCurrentPosition(path),
    label: label ? label.toLowerCase().replaceAll(' ', '_') : '',
    type,
    step: '',
    category: '',
    action: '',
  })
}

export const handleClickCtaTracking = (label: string, path: string) => {
  trackingGaEventNew('click_cta', {
    searchTerm: '',
    position: getCurrentPosition(path),
    label: label ? label.toLowerCase().replaceAll(' ', '_') : '',
    type: '',
    step: '',
    category: '',
    action: '',
  })
}

export const handleSelectContentTracking = (
  label: string,
  type: 'article' | 'blog' | 'catalog',
  category = '',
  path: string
) => {
  trackingGaEventNew('select_content', {
    searchTerm: '',
    position: getCurrentPosition(path),
    label: label ? label.toLowerCase().replaceAll(' ', '_') : '',
    type: type ? type.toLowerCase().replaceAll(' ', '_') : '',
    step: '',
    category: category ? category.toLowerCase().replaceAll(' ', '_') : '',
    action: '',
  })
}

export const handleFooterTracking = (label: string, type: string) => {
  trackingGaEventNew('footer', {
    searchTerm: '',
    position: '',
    label: label ? label.toLowerCase().replaceAll('-', '_') : '',
    type: type ? type.toLowerCase().replaceAll('-', '_') : '',
    step: '',
    category: '',
    action: '',
  })
}

export const handleHeaderTracking = (label: string) => {
  trackingGaEventNew('header', {
    searchTerm: '',
    position: '',
    label: label ? label.toLowerCase().replaceAll('-', '_').replaceAll(' ', '_') : '',
    type: '',
    step: '',
    category: '',
    action: '',
  })
}

export const handleHeaderMenuTracking = (label: string, level: number) => {
  let positionLevel = ''
  switch (level) {
    case 0:
      positionLevel = 'first_level_menu'
      break
    case 1:
      positionLevel = 'second_level_menu'
      break
    case 2:
      positionLevel = 'third_level_menu'
      break
    default:
      positionLevel = ''
  }

  trackingGaEventNew('menu', {
    searchTerm: '',
    position: positionLevel,
    label: label ? label.toLowerCase().replaceAll('-', '_').replaceAll(' ', '_') : '',
    type: '',
    step: '',
    category: '',
    action: '',
  })
}

export const handleSearchTypeTracking = (searchTerm: string) => {
  trackingGaEventNew('search', {
    searchTerm: searchTerm ? searchTerm.toLowerCase().replaceAll(' ', '_') : '',
    position: '',
    label: '',
    type: '',
    step: '',
    category: '',
    action: '',
  })
}

export const handleSearchClickTracking = (label: string, type: string) => {
  trackingGaEventNew('search_click', {
    searchTerm: '',
    position: '',
    label: label ? label.toLowerCase().replaceAll(' ', '_') : '',
    type: type ? type.toLowerCase().replaceAll(' ', '_') : '',
    step: '',
    category: '',
    action: '',
  })
}

export const handleFindStoreCtaTracking = (path: string) => {
  trackingGaEventNew('find_store_cta', {
    searchTerm: '',
    position: getCurrentPosition(path),
    label: '',
    type: '',
    step: '',
    category: '',
    action: '',
  })
}

export const handleContattaciTracking = (status: string, type: string) => {
  trackingGaEventNew('contact_us', {
    searchTerm: '',
    position: '',
    label: '',
    type: type ? type.toLowerCase().replaceAll(' ', '_') : '',
    step: status,
    category: '',
    action: '',
  })
}

export const handleTrackingSearch = (searchTerm) => {
  trackingGaEventNew('search', {
    searchTerm: searchTerm,
    // 'position' : $$$position$$$,
    // 'label' : $$$label$$$,
    // 'category': $$$category$$$
    // 'type' : $$$type$$$,
  })
}

export const handleBrandLinkTracking = (label: string, path: string) => {
  const parts = path.split('/')
  const filteredParts = parts.filter((part) => part !== '')
  const lastElement = filteredParts.at(-1)

  trackingGaEventNew('brand_link', {
    searchTerm: '',
    position:
      path == '/'
        ? 'homepage'
        : lastElement
        ? lastElement.toLowerCase().replaceAll(' ', '_').replaceAll('-', '_')
        : '',
    label: label ? label.toLowerCase().replaceAll(' ', '_').replaceAll('-', '_') : '',
    type: '',
    step: '',
    category: '',
    action: '',
  })
}

export const handleDowloadFileTracking = (label: string, path: string) => {
  trackingGaEventNew('file_download', {
    searchTerm: '',
    position: getCurrentPosition(path),
    label: label ? label.toLowerCase().replaceAll(' ', '_').replaceAll('-', '_') : '',
    type: '',
    step: '',
    category: '',
    action: '',
  })
}

export const handleSocialTracking = (label: string) => {
  trackingGaEventNew('social', {
    searchTerm: '',
    position: '',
    label: label ? label.toLowerCase().replaceAll(' ', '_').replaceAll('-', '_') : '',
    type: '',
    step: '',
    category: '',
    action: '',
  })
}

export const handleFormCompletationTracking = (label: string, type: string) => {
  trackingGaEventNew('form_submit', {
    searchTerm: '',
    position: '',
    label: label ? label.toLowerCase().replaceAll(' ', '_').replaceAll('-', '_') : '',
    type: type ? type.toLowerCase().replaceAll(' ', '_').replaceAll('-', '_') : '',
    step: '',
    category: '',
    action: '',
  })
}

export const handleFormStartTracking = (label: string, type: string) => {
  trackingGaEventNew('form_start', {
    searchTerm: '',
    position: '',
    label: label ? label.toLowerCase().replaceAll(' ', '_').replaceAll('-', '_') : '',
    type: type ? type.toLowerCase().replaceAll(' ', '_').replaceAll('-', '_') : '',
    step: '',
    category: '',
    action: '',
  })
}

export const handleTimelineTracking = (label: string, position: string) => {
  trackingGaEventNew('timeline', {
    searchTerm: '',
    position: position,
    label: label ? label.toLowerCase().replaceAll(' ', '_').replaceAll('-', '_') : '',
    type: '',
    step: '',
    category: '',
    action: '',
  })
}

export const handleStoreLocatorSearchTracking = (searchTerm: string) => {
  trackingGaEventNew('store_locator_search', {
    searchTerm: searchTerm
      ? searchTerm.toLowerCase().replaceAll(' ', '_').replaceAll('-', '_')
      : '',
    position: '',
    label: '',
    type: '',
    step: '',
    category: '',
    action: '',
  })
}

export const handleStoreLocatorDetailsTracking = (
  label: string,
  type: string,
  searchTerm: string
) => {
  trackingGaEventNew('store_locator_details', {
    searchTerm: searchTerm
      ? searchTerm.toLowerCase().replaceAll(' ', '_').replaceAll('-', '_')
      : '',
    position: '',
    label: label ? label.toLowerCase().replaceAll(' ', '_').replaceAll('-', '_') : '',
    type: type ? type.toLowerCase().replaceAll(' ', '_').replaceAll('-', '_') : '',
    step: '',
    category: '',
    action: '',
  })
}
